const traccarWhite = '#FFF';
const traccarBlack = '#000';
const traccarPurple = '#333366';
const traccarGreen = '#4CAF50';
const traccarRed = '#CC2222';
const traccarGray = '#888888';
const traccarBrown = '#A52A2A';
const traccarGold = '#FFD700';
const traccarSilver = '#C0C0C0';
const traccarBlue = '#0000FF';
const traccarYellow = '#ffeb3b';


export default {
  common: {
    purple: traccarPurple,
    Gold: traccarGold,
    Silver: traccarSilver,
    Brown: traccarBrown,
    Blue: traccarBlue,
    Black: traccarBlack,
    White: traccarWhite,
    Red: traccarRed,
    Green: traccarGreen,
    Gray: traccarGray,
    Yellow: traccarYellow,
  },
  primary: {
    main: traccarPurple,
  },
  secondary: {
    main: traccarGreen,
    contrastText: traccarWhite,
  },
  error: {
    main: traccarRed,
    contrastText: traccarBlack,
  },
  colors: {
    Gold: {
      color: traccarGold,
    },
    Silver: {
      color: traccarSilver,
    },
    Brown: {
      color: traccarBrown,
    },
    Blue: {
      color: traccarBlue,
    },
    Black: {
      color: traccarBlack,
    },
    White: {
      color: traccarWhite,
    },
    Red: {
      color: traccarRed,
    },
    Green: {
      color: traccarGreen,
    },
    Gray: {
      color: traccarGray,
    },
    Yellow: {
      color: traccarYellow,
    },
  },
};
